import { Stack } from 'expo-router';

import { getScreenTitleHeader } from '../../components/get-screen-title-header';

/** Stable component identity for React Navigation — do not call getScreenTitleHeader() inside render. */
const drawerAccountStackHeader = getScreenTitleHeader({
  backStyle: 'back',
  cannotGoBackHref: '/account',
});
const drawerAccountIndexHeader = getScreenTitleHeader({
  backStyle: 'dynamic',
  cannotGoBackHref: '/',
});

export default function DrawerLayout() {
  return (
    <Stack
      screenOptions={{
        header: drawerAccountStackHeader,
      }}
    >
      <Stack.Screen
        name="account/index"
        options={{
          title: 'My Account',
          header: drawerAccountIndexHeader,
        }}
      />
      <Stack.Screen
        name="account/info"
        options={{
          title: 'My Account',
        }}
      />
      <Stack.Screen
        name="account/orders"
        options={{
          title: 'Recent Orders',
        }}
      />
      <Stack.Screen
        name="account/payment"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="account/gift-cards"
        options={{
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="diagnostics"
        options={{
          title: 'Diagnostics',
        }}
      />
    </Stack>
  );
}
